export enum PostInsightEntityType {
    STORY = 'story',
    POST = 'post',
    REEL = 'reel',
}
